import { createNameContext } from '@showroomjs/ui';
import * as React from 'react';
const MenuContext = createNameContext('Menu', []);
export const MenuContextProvider = (props) => {
    const result = React.useMemo(() => filterHiddenItems(props.sections), [props.sections]);
    return (React.createElement(MenuContext.Provider, { value: result }, props.children));
};
export const useMenu = () => React.useContext(MenuContext);
const filterHiddenItems = (sections) => {
    const result = [];
    sections.forEach((section) => {
        if ('slug' in section && section.slug === '') {
            return;
        }
        if (section.type === 'link') {
            result.push(section);
        }
        else {
            if (!section.hideFromSidebar) {
                if (section.type === 'group') {
                    const filteredItems = filterHiddenItems(section.items);
                    if (filteredItems.length > 0) {
                        result.push(Object.assign(Object.assign({}, section), { items: filteredItems }));
                    }
                }
                else {
                    result.push(section);
                }
            }
        }
    });
    return result;
};
//# sourceMappingURL=use-menu.js.map